import { ACCOUNT_TYPE } from "../utils/constants";
export const sidebarLinks = [
  
  {
    id: 0,
    name: "Refer Lead",
    path: "/dashboard/rm",
    type: ACCOUNT_TYPE.USER,
  },
  
  {
    id: 1,
    name: "Refer Lead List",
    path: "/dashboard/refer-lead-list",
    type: ACCOUNT_TYPE.USER,
  },
 
  {
    id: 2,
    name: "Fetch Lead List",
    path: "/dashboard/fetch-lead-list",
    type: ACCOUNT_TYPE.USER,
  },
  {
    id: 3,
    name: "Under Us Approved",
    path: "/dashboard/under-us-approved",
    type: ACCOUNT_TYPE.USER,
  },
  {
    id: 4,
    name: "Coded Approved",
    path: "/dashboard/coded-approved-list",
    type: ACCOUNT_TYPE.USER,
  },
  {
    id: 5,
    name: "F&O Approved",
    path: "/dashboard/aoma-approved-list",
    type: ACCOUNT_TYPE.USER,
  },
  {
    id: 6,
    name: "Your Clients",
    path: "/dashboard/your-clients-list",
    type: ACCOUNT_TYPE.USER,
  },
  {
    id: 7,
    name: "MS Teams",
    path: "/dashboard/ms-teams-list",
    type: ACCOUNT_TYPE.USER,
  },
  // {
  //   id: 8,
  //   name: "SIP",
  //   path: "/dashboard/sip",
  //   type: ACCOUNT_TYPE.USER,
  // },
  {
    id: 9,
    name: "Analytics",
    path: "/dashboard/rm/analytics",
    type: ACCOUNT_TYPE.USER,
  },
  {
    id: 10,
    name: "Payments",
    path: "/dashboard/your/payment",
    type: ACCOUNT_TYPE.USER,
  },
  {
    id: 11,
    name: "Create Role",
    path: "/dashboard/admin",
    type: ACCOUNT_TYPE.ADMIN,
    
  },
  {
    id: 12,
    name: "View Team Profile",
    path: "/dashboard/view-team-profile",
    type: ACCOUNT_TYPE.ADMIN,
    
  },
  {
    id: 13,
    name: "Basic Ms Team ID Pass",
    path: "/dashboard/ms-team-id-pass",
    type: ACCOUNT_TYPE.ADMIN,
  },
  {
    id: 14,
    name: "Advance Ms Team ID Pass",
    path: "/dashboard/advance-ms-team-id-pass",
    type: ACCOUNT_TYPE.ADMIN,
  },
  {
    id: 15,
    name: "Under Us Request",
    path: "/dashboard/under-us-request",
    type: ACCOUNT_TYPE.ADMIN,
  },
  {
    id: 16,
    name: "Coded Request",
    path: "/dashboard/coded-requests",
    type: ACCOUNT_TYPE.ADMIN,
  },
  {
    id: 17,
    name: "Old Coded Request",
    path: "/dashboard/old-coded-requests",
    type: ACCOUNT_TYPE.ADMIN,
  },
  {
    id: 18,
    name: "F&O Request",
    path: "/dashboard/aoma-requests",
    type: ACCOUNT_TYPE.ADMIN,
  },
  {
    id: 19,
    name: "Trade Active Requests",
    path: "/dashboard/activation-requests",
    type: ACCOUNT_TYPE.ADMIN,
  },
  {
    id: 20,
    name: "MS Teams Requests",
    path: "/dashboard/ms-teams-requests",
    type: ACCOUNT_TYPE.ADMIN,
  },
  {
    id: 21,
    name: "Advance MS Teams Requests",
    path: "/dashboard/advance-ms-teams-requests",
    type: ACCOUNT_TYPE.ADMIN,
  },
  // {
  //   id: 22 ,
  //   name: "SIP Requests",
  //   path: "/dashboard/sip-requests",
  //   type: ACCOUNT_TYPE.ADMIN,
  // },
  {
    id: 23,
    name: "Delete Requests",
    path: "/dashboard/delete-requests",
    type: ACCOUNT_TYPE.ADMIN,
  },
  {
    id: 24,
    name: "Universal Approve",
    path: "/dashboard/universal-approve",
    type: ACCOUNT_TYPE.ADMIN,
  },
  {
    id: 25,
    name: "Analytics",
    path: "/dashboard/admin-analytics",
    type: ACCOUNT_TYPE.ADMIN,
  },
  {
    id: 26,
    name: "Payments",
    path: "/dashboard/admin/payments",
    type: ACCOUNT_TYPE.ADMIN,
  },
  {
    id: 27,
    name: "Conversion Points",
    path: "/dashboard/conversion/points",
    type: ACCOUNT_TYPE.ADMIN,
  },
   {
    id: 28,
    name: "Refer Old Client List",
    path: "/dashboard/refer/old/client",
    type: ACCOUNT_TYPE.RM,
  },
  {
    id: 29,
    name: "Old Basic Ms Teams Clients",
    path: "/dashboard/old/basic/msteams/clients",
    type: ACCOUNT_TYPE.RM,
  },
  {
    id: 30,
    name: "Old Advance MS Teams Clients",
    path: "/dashboard/old/advance/msteams/clients",
    type: ACCOUNT_TYPE.RM,
  },
  {
    id: 31,
    name: "Old My Clients",
    path: "/dashboard/old/my/clients",
    type: ACCOUNT_TYPE.RM,
  },
  {
    id: 32,
    name: "My New Clients for Call",
    path: "/dashboard/my/new/clients/for/call",
    type: ACCOUNT_TYPE.RM,
  },
  {
    id: 33,
    name: "Basic Ms Teams Clients",
    path: "/dashboard/main/rm/basic/teams/clients",
    type: ACCOUNT_TYPE.RM,
  },
   {
    id: 34,
    name: "My Clients",
    path: "/dashboard/main/rm/my/clients",
    type: ACCOUNT_TYPE.RM,
  },
  {
    id: 35,
    name: "Advance Ms Teams Clients",
    path: "/dashboard/main/rm/advance/ms/teams/clients",
    type: ACCOUNT_TYPE.RM,
  },
  {
    id: 36,
    name: "Advance Ms Teams Clients SS upload",
    path: "/dashboard/main/rm/advance/msteams/clients/screenshot/upload",
    type: ACCOUNT_TYPE.RM,
  },
  {
    id: 37,
    name: "Universal Search",
    path: "/dashboard/main/rm/universal/search",
    type: ACCOUNT_TYPE.RM,
  },
  {
    id: 38,
    name: "Payments",
    path: "/dashboard/main/rm/payments",
    type: ACCOUNT_TYPE.RM,
  },
  {
    id: 39,
    name: "Basic Ms Team ID Pass",
    path: "/dashboard/ms-team-id-pass",
    type: ACCOUNT_TYPE.TEAMSUSER,
  },
  {
    id: 40,
     name: "Advance Ms Team ID Pass",
    path: "/dashboard/advance-ms-team-id-pass",
    type: ACCOUNT_TYPE.TEAMSUSER,
  },
  {
    id: 41,
    name: "Create Role",
    path: "/dashboard/admin",
    type: ACCOUNT_TYPE.MANAGER,
    
  },
  {
    id: 42,
    name: "View Team Profile",
    path: "/dashboard/view-team-profile",
    type: ACCOUNT_TYPE.MANAGER,
    
  },
  {
    id: 43,
    name: "Basic Ms Team ID Pass",
    path: "/dashboard/ms-team-id-pass",
    type: ACCOUNT_TYPE.MANAGER,
  },
  {
    id: 44,
    name: "Advance Ms Team ID Pass",
    path: "/dashboard/advance-ms-team-id-pass",
    type: ACCOUNT_TYPE.MANAGER,
  },
  {
    id: 45,
    name: "Under Us Request",
    path: "/dashboard/under-us-request",
    type: ACCOUNT_TYPE.MANAGER,
  },
  {
    id: 46,
    name: "Coded Request",
    path: "/dashboard/coded-requests",
    type: ACCOUNT_TYPE.MANAGER,
  },
  {
    id: 47,
    name: "Old Coded Request",
    path: "/dashboard/old-coded-requests",
    type: ACCOUNT_TYPE.MANAGER,
  },
  {
    id: 48,
    name: "AOMA Request",
    path: "/dashboard/aoma-requests",
    type: ACCOUNT_TYPE.MANAGER,
  },
  {
    id: 49,
    name: "Activation Requests",
    path: "/dashboard/activation-requests",
    type: ACCOUNT_TYPE.MANAGER,
  },
  {
    id: 50,
    name: "MS Teams Requests",
    path: "/dashboard/ms-teams-requests",
    type: ACCOUNT_TYPE.MANAGER,
  },
  {
    id: 51,
    name: "Advance MS Teams Requests",
    path: "/dashboard/advance-ms-teams-requests",
    type: ACCOUNT_TYPE.MANAGER,
  },
  {
    id: 52 ,
    name: "SIP Requests",
    path: "/dashboard/sip-requests",
    type: ACCOUNT_TYPE.MANAGER,
  },
  {
    id: 53,
    name: "Delete Requests",
    path: "/dashboard/delete-requests",
    type: ACCOUNT_TYPE.MANAGER,
  },
  {
    id: 54,
    name: "Universal Approve",
    path: "/dashboard/universal-approve",
    type: ACCOUNT_TYPE.MANAGER,
  },
  {
    id: 55,
    name: "Analytics",
    path: "/dashboard/admin-analytics",
    type: ACCOUNT_TYPE.MANAGER,
  },
  
  
 
  
];